import * as React from 'react';
import Icon from '../icon/Icon';
import {
  Tooltip,
  Fab,
  Box,
  Link,
  useMediaQuery,
  IconButton,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

const FabComp = ({
  label,
  open,
  destination,
  src,
  place,
  onClick
}) => {
  const [showTooltip, setShowTooltip] = React.useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  React.useEffect(() => {
    if (isSmallScreen) {
      setShowTooltip(true);
    } else {
      setShowTooltip(false); 
    }
  }, [isSmallScreen]);

  const handleTooltipClose = () => {
    setShowTooltip(false);
  };

  const tooltipContent = (
    <Box
      sx={{
        display: {
          xs: "flex",
          sm: "flex",
          md: "none",
          lg: "none",
          xl: "none",
        },
        alignItems: "center",
        gap: 1,
        zIndex: "2"
      }}
    >
      <Typography variant="body3">
        {label}
      </Typography>
      <IconButton
        size="small"
        onClick={handleTooltipClose}
        sx={{
          color: "#FEFEFE",
          padding: "2px",
          "&:hover": { opacity: 0.8 },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );

  return (
    <Box
      sx={{
        '& > :not(style)': {
          m: 5,
          position: 'absolute',
          right: 0,
          bottom: 0,
        },
      }}
    >
        <Tooltip
          title={
            !open && !showTooltip ? label:
            null
          }
          placement={place}
          arrow
        >
      <Tooltip
        title={tooltipContent}
        placement="top-end"
        arrow
        open={showTooltip && isSmallScreen}
        onClose={handleTooltipClose}
        disableFocusListener
        disableHoverListener
        disableTouchListener
      >
        <Link
          href={destination !== "none" ? destination : null}
          underline="hover"
          sx={{ textDecoration: 'none' }}
        >
          <Fab
            onClick={onClick}
            aria-label="fab"
            sx={{
              backgroundColor: '#2e2d2d',
              boxShadow: '0 2px 10px rgba(0,0,0,0.5)',
              transition: 'background-color 0.3s ease, transform 0.2s ease',
              '&:hover': {
                backgroundColor: '#2e2d2d', 
                transform: 'scale(1.2)',
              },
            }}
          >
            <Icon
              src={src}
              size="small"
            />
          </Fab>
        </Link>
        </Tooltip>
      </Tooltip>
    </Box>
  );
};

export default FabComp;
